import AddIcon from '@mui/icons-material/Add';
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';
import ReplayIcon from '@mui/icons-material/Replay';
import { Button, Stack, Typography } from '@mui/material';
import { openUrl } from '@tauri-apps/plugin-opener';

interface TagNotAddedViewProps {
    onScanAgain: () => void;
    serial: string;
}

export default function TagNotAddedView({ onScanAgain, serial }: Readonly<TagNotAddedViewProps>) {
    const handleRegisterTag = async () => {
        const url = `${process.env.EXPO_PUBLIC_MANAGER_URL!}/tagmanager?register=true&serial=${serial}`;
        try {
            await openUrl(url);
        } catch (error) {
            console.error('Failed to open with Tauri opener, falling back to window.open', error);
            window.open(url, '_blank', 'noopener,noreferrer');
        }
    };

    return (
        <Stack
            direction="column"
            spacing={2}
            sx={{
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
            }}
        >
            <ErrorOutlineRoundedIcon sx={{ color: 'warning.main', fontSize: 56 }} />
            <Typography color="warning" variant="body2">
                This tag is not registered in Renki system.
            </Typography>
            <Stack spacing={2}>
                <Button
                    color="primary"
                    onClick={handleRegisterTag}
                    size="large"
                    startIcon={<AddIcon fontSize="inherit" />}
                    variant="contained"
                >
                    Register Tag
                </Button>
                <Button
                    color="inherit"
                    onClick={onScanAgain}
                    size="large"
                    startIcon={<ReplayIcon fontSize="inherit" />}
                    variant="outlined"
                >
                    Scan Again
                </Button>
            </Stack>
        </Stack>
    );
}
